/* eslint-disable react/jsx-curly-newline */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useContext, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useHistory, useParams } from 'react-router-dom';
import { useRecoilState, useSetRecoilState } from 'recoil';
import LoadingOverlay from 'react-loading-overlay';
import AuthenticatedContext from '../../context/AuthenticatedContext';
import { backPageFlg, pageTitle } from '../../context/PageRecoil';
import { DeviceDetail } from '../../models/data/Device';
import { pathnames } from '../../api';
import { requestDeviceDetail } from '../../api/device';
import useStyles from '../../css/style';
import { OneEquipment } from '../../models/data/Equipment';
import { requestOneEquipment } from '../../api/equipment';
import DataDisp from './datadisp';
import { routeName } from '../../App';
import useErrorHandling from '../errorCheck';

type UserPageParams = {
  eqid: string;
  id: string;
};
/**
 * 設備機器一覧画面
 */
const DeviceDetailPage: React.FunctionComponent = () => {
  const history = useHistory();
  const authContext = useContext(AuthenticatedContext); // ログインユーザの情報を取得
  const classes = useStyles();
  const [loading, setLoading] = useState(true); // ロード画面の状態管理
  const { eqid, id } = useParams<UserPageParams>();
  const [backFlg, setBackFlg] = useRecoilState(backPageFlg);
  const [data, setData] = useState<DeviceDetail>(); // 表示するメインデータ
  const [data2, setData2] = useState<OneEquipment>();
  const { errorCheck } = useErrorHandling();

  const setPageTitle = useSetRecoilState(pageTitle);
  React.useEffect(() => {
    return setPageTitle({ pageTitle: '機器詳細' }); // ページのタイトルを設定
  }, [setPageTitle]);

  // APIのURL
  const urlDeviceDetail = history.createHref({
    pathname: pathnames.deviceDetail,
  }); // 機器一覧取得
  const urlOneEquipment = history.createHref({
    pathname: pathnames.oneEquipment,
  });

  // 初回画面表示時の処理
  useEffect(() => {
    setLoading(true); // 非同期処理前にsetLoading(true)
    Promise.all([
      requestOneEquipment(urlOneEquipment, {
        equipmentId: Number(eqid),
      }),
      requestDeviceDetail(urlDeviceDetail, {
        custEqId: Number(eqid),
        mstId: Number(id),
      }),
    ])
      .then((responses) => {
        setData2(responses[0].data);
        setData(responses[1].data);
      })
      .catch((error) => {
        errorCheck(error); // エラーの確認
      })
      .finally(() => {
        setLoading(false); // 非同期処理後にsetLoading(false)
      });
  }, []);

  return (
    <LoadingOverlay
      active={loading}
      className={classes.load}
      spinner
      text="データを読み込んでいます..."
    >
      <div className={classes.root}>
        <Button
          variant="primary"
          className="my-2"
          onClick={() => {
            setBackFlg({ ...backFlg, deviceList: true });
            history.push(`${routeName.deviceList}/${eqid}`);
          }}
        >
          戻る
        </Button>
        <br />
        <DataDisp userdata={authContext} data={data} data2={data2} />
      </div>
    </LoadingOverlay>
  );
};

export default DeviceDetailPage;
